(() => {
  'use strict';
  const initialize = root => {
    root.querySelectorAll('[data-marquee]').forEach(banner => {
      if (banner.dataset.ready) return;
      banner.dataset.ready = 'true';
      const button = banner.querySelector('[data-marquee-toggle]');
      button.addEventListener('click', () => {
        const paused = banner.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.play : button.dataset.pause);
        button.textContent = paused ? '▶' : 'Ⅱ';
      });
    });
    root.querySelectorAll('[data-ov-product]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const select = section.querySelector('[data-variant]');
      const image = section.querySelector('.ov-cover');
      const imageLink = section.querySelector('.ov-cover-link');
      const add = section.querySelector('[data-add]');
      const express = section.querySelector('.ov-express');
      function showImage(url) {
        if (!image || !url) return;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = url;
        imageLink.href = url;
      }
      function updateVariant() {
        const option = select.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        section.querySelector('[data-price]').textContent = option.dataset.price;
        add.disabled = !available;
        add.textContent = available ? add.dataset.label : add.dataset.unavailable;
        if (express) express.hidden = !available;
        showImage(option.dataset.image);
        section.querySelectorAll('[data-photo]').forEach(link => link.removeAttribute('aria-current'));
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
      }
      select.addEventListener('change', updateVariant);
      section.querySelectorAll('[data-photo]').forEach(link => {
        link.addEventListener('click', event => {
          if (!image) return;
          event.preventDefault();
          showImage(link.href);
          section.querySelectorAll('[data-photo]').forEach(other => other.removeAttribute('aria-current'));
          link.setAttribute('aria-current', 'true');
        });
      });
      section.querySelector('form').addEventListener('submit', event => {
        if (select.selectedOptions[0]?.dataset.available !== 'true') event.preventDefault();
      });
    });
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ov-reveal');
            observer.unobserve(entry.target);
          }
        }
      }, {threshold: .1});
      root.querySelectorAll('.ov-guide-grid article,.ov-related .ov-card').forEach(el => observer.observe(el));
    }
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
